export default "__VITE_ASSET__890655bb__"